import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CodeOrdersComponent } from '@app/features/code-orders/code-orders/code-orders.component';
import { AddCodeOrderComponent } from '@app/features/code-orders/add-code-order/add-code-order.component';
import { ViewCodeOrderComponent } from '@app/features/code-orders/view-code-order/view-code-order.component';

const routes: Routes = [
  { path: '', component: CodeOrdersComponent },
  { path: 'add', component: AddCodeOrderComponent },
  { path: ':codeOrderId', component: ViewCodeOrderComponent },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class CodeOrdersRoutingModule { }
